import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

var router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: [
        {
            path: "/",
            name: 'Home',
            component: () => import("@/views/Home"),
            meta: {
                title: ''
            }
        },
        {
            path: "/Home",
            name: 'Home',
            component: () => import("@/views/Home"),
            meta: {
                title: ''
            }
        },
        {
            path: "/Introduct",
            name: 'Introduct',
            component: () => import("@/views/Introduct"),
            meta: {
                title: ''
            }
        },
        {
            path: "/Contact",
            name: 'Contact',
            component: () => import("@/views/Contact"),
            meta: {
                title: ''
            }
        },
    ]
});

export default router;
